import { RoleScope } from '../interfaces/role-scope.interface';
import { DataServices } from '../enums/data-services.enum';
import { AccessServiceActions } from '../enums/service-actions/access-service-actions.enum';
import { DashboardServiceActions } from '../enums/service-actions/dashboard-service-actions.enum';
import { InvestigatorServiceActions } from '../enums/service-actions/investigator-service-actions.enum';
import { OrganizationServiceActions } from '../enums/service-actions/organization-service-actions.enum';
import { PoliciesServiceActions } from '../enums/service-actions/policies-service-actions.enum';
import { ApiKeysServiceActions } from '../enums/service-actions/api-keys-service-actions.enum';
import { AccessType } from '../enums/access-type.enum';
import { HealthCheckerServiceActions } from '../enums/service-actions/health-checker-actions.enum';
import { FingerprintServiceActions } from '../enums/service-actions/fingerprint-service-actions.enum';

const servicesActionsMap = {
  [DataServices.Access]: AccessServiceActions,
  [DataServices.Dashboard]: DashboardServiceActions,
  [DataServices.Investigator]: InvestigatorServiceActions,
  [DataServices.Organizations]: OrganizationServiceActions,
  [DataServices.Policies]: PoliciesServiceActions,
  [DataServices.ApiKeys]: ApiKeysServiceActions,
  [DataServices.HealthChecker]: HealthCheckerServiceActions,
  [DataServices.Fingerprint]: FingerprintServiceActions,
};

export const permissionsHelper: (roleScopes: Array<RoleScope>) => Array<string> =
  (roleScopes: Array<RoleScope>) => {
    return roleScopes.reduce((scopes, rs) => {
      if (rs.service === DataServices.ALL) {
        scopes = scopes.concat(handleAllServicesPermission(rs.access_type));
      } else {
        scopes = scopes.concat(handleRoleServiceScope(rs));
      }

      return scopes;
    }, []);
  };

function handleRoleServiceScope(rs: RoleScope): Array<string> {
  const dataServiceActions = servicesActionsMap[rs.service];
  const result = [];

  if ( !dataServiceActions ) return result;

  if (rs.action === dataServiceActions.ALL) {
    const actions = Object.values(dataServiceActions).filter(dsa => dsa !== dataServiceActions.ALL);

    actions.forEach(action => {
      createAccessScopes(rs.service, <string>action, rs.access_type, result);
    });
  } else {
    createAccessScopes(rs.service, rs.action, rs.access_type, result);
  }

  return result;
}

function handleAllServicesPermission(access: AccessType): Array<string> {
  const services = Object.values(DataServices).filter(s => s !== DataServices.ALL);
  const result = [];

  services.forEach((serviceKey) => {
    const dataServiceActions = servicesActionsMap[serviceKey];
    const actions = Object.values(dataServiceActions).filter(dataServiceAction => dataServiceAction !== dataServiceActions.ALL);

    actions.forEach((action) => {
      createAccessScopes(serviceKey, <string>action, access, result);
    });
  });

  return result;
}

function createAccessScopes(
  service: string,
  action: string,
  access: AccessType,
  scopes: Array<string>,
): void {
  switch (access) {
    case AccessType.All: {
      scopes.push(`${service}.${action}.${AccessType.Read}`);
      scopes.push(`${service}.${action}.${AccessType.Write}`);
      break;
    }
    case AccessType.Write: {
      scopes.push(`${service}.${action}.${AccessType.Write}`);
      break;
    }
    case AccessType.Read: {
      scopes.push(`${service}.${action}.${AccessType.Read}`);
      break;
    }
  }
}
